import {
  LEGALMASTER_LOADING,
  GET_LEGALMASTER,
  GET_LEGALMASTER_SUCCESS,
  GET_LEGALMASTER_FAIL,
  ADD_LEGALMASTER_SUCCESS,
  ADD_LEGALMASTER_FAIL,
  DELETE_LEGALMASTER_SUCCESS,
  DELETE_LEGALMASTER_FAIL,
  UPDATE_LEGALMASTER_SUCCESS,
  UPDATE_LEGALMASTER_FAIL,
  LEGALMASTER_RESET
} from "./actionType";

const INIT_STATE = {
  legalMasters: [],
  error: {},
};

const LegalMaster = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALMASTER_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALMASTER:
          return {
            ...state,
            legalMasters: action.payload.data,
            isLegalMasterCreated: false,
            isLegalMasterSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALMASTER_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALMASTER_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalMasterCreated: false,
            isLegalMasterSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALMASTER: {
      return {
        ...state,
        isLegalMasterCreated: false,
        loading: true,
      };
    }

    case LEGALMASTER_LOADING: {
      return {
        ...state,
        isLegalMasterCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALMASTER_SUCCESS:
      return {
        ...state,
        isLegalMasterCreated: true,
        loading: false,
        legalMasters: [action.payload.data, ...state.legalMasters],
      };

    case ADD_LEGALMASTER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALMASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        isLegalMasterCreated: true,
        legalMasters: state.legalMasters.filter(
          legalMaster => legalMaster.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALMASTER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALMASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        isLegalMasterCreated: true,
        legalMasters: state.legalMasters.map(legalMaster =>
          legalMaster.id.toString() === action.payload.data.id.toString() ? { ...legalMaster, ...action.payload.data } : legalMaster
        ),
      };

    case UPDATE_LEGALMASTER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALMASTER_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalMaster;